import React from 'react'
import Header from './common/Header'
import Footer from './common/Footer'
import SEO from '../components/common/SEO'
import SlidersVendor from './sliders/vendors/SlidersVendor'
import Sliders2_Vendor from './sliders/vendors/Sliders2_Vendor'
import Sliders3_Vendor from './sliders/vendors/Sliders3_Vendor'

function VendorDetails() {

  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".vendor-details-page");

    if (!element) return; 

    if (window.innerWidth >= 1024) {
        element.classList.add("pt-4"); 
        
    } else {
        element.classList.remove("pt-4"); 
      
    }
  }

  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);


  
  return (
    <div>
      <SEO title="Vendor Details | Mangoloops" description="Learn more about our partner vendors and the services they offer. Detailed information on travel, healthcare, and more." />
      <Header />

      <div className="banner-content vendor-banner-sec">
        <div className="vendor-banner">
          <div className="vendor-banner-img">
            <img className="banner-img" src="assets/img/breadcrumb/vendor-banner.jpg" alt="" width="100%" />
          </div>
        </div>
      </div>
      <div className="vendor-info-main-sec">
        <div className="container">
          <div className="row">

            <div className="col-lg-4 vendor-logo">
              <div className="profile_img">
                <img src="https://www.areaonline.in/uploads/listing/16571857351657185735.jpg"
                  className="circle-plus" />
              </div>
            </div>

            <div className="col-lg-8">
              <div className="">
                <div className="mflex acenter company-name vendor-details-page"><span className="company-name-span">Viva Super Market (Apparels, Women Traditional)</span></div>
                <div className="pt-0 company-location">Vasai Virar, Maharashtra, India</div>
                <div className="pt-1 company-address">Thakur Arcade, 1st Floor - Raja Chatrapati Shivaji Marg, Near Railway Station 401303 </div>
              </div>

              <div className="vendor-contact-details vendor-social-icon-div">
                <div className="vendors-contact-btn vendor_social_icons">
                  <div className="">
                    <img src="assets/img/social-icon/whatsapp.png" alt="" /></div>
                  <div className="">
                    <img src="assets/img/social-icon/call.png" alt="" /></div>
                  <div className=""><img src="assets/img/social-icon/gmail.png" alt="" /></div>
                  <div className=""><img src="assets/img/social-icon/google-maps.png" alt="" /></div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

      <div className="about-company-main-sec">
        <div className="container">
          <div className="row">
            <div className="boxv1">
              <h5 className="tour-details-h5">About Company</h5>

              <p className="description-p">Himachal Pradesh, with its snow-capped mountain peaks, lush green countryside, sparkling lakes, dense forests, and enchanting religious sites, is truly a paradise for tourists. This northern state, blessed with nature's beauty, offers a serene escape for travelers seeking tranquility and adventure alike. From the majestic Himalayan landscapes to the spiritual aura of its temples, Himachal Pradesh promises an unforgettable experience.</p>

              <p className="description-p">From the majestic Himalayan landscapes to the spiritual aura of its ancient temples, Himachal Pradesh promises an unforgettable and awe-inspiring travel experience. The picturesque scenery, vibrant festivals, and rich cultural heritage of this region attract countless visitors from across the world every year.</p>

              <p className="description-p">Mangoloops offers a wide range of Himachal Pradesh holiday packages, catering to different preferences and budgets. These packages provide an excellent opportunity to explore the state’s picturesque landscapes and cultural richness. So, plan your Himachal Pradesh vacation soon and immerse yourself in the charm and splendor of this captivating destination.</p>

            </div>

          </div>
        </div>
      </div>

      <SlidersVendor />

      <div className="about-company-main-sec">
        <div className="container">
        <div className="row">
            <div className="boxv1">
                <h5 className="tour-details-h5">Cabs Services</h5>
                <div className="row pt-0 pb-3 vendor-gap">
                    <div className="col-lg-4">
                        <div className="ecpl_rbx tour-packaging-box-width">
                            <div className="mgdestn"> <a href="#"> 
                              <img src="assets/img/hotels/hotels-places/del-sm.webp" alt="Delhi"/> </a> </div>
                            <div className="_pckgdscrptn">
                                <h5 className="htlnking"><a href="#" className="cab-service-vendor">City To City-Outstation Cabs</a></h5>
                                <div className="htlnking vendors-cab-sub-text">Best Price Guarantee, professional services, timely pick-up & drop-off and more!</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="ecpl_rbx tour-packaging-box-width">
                            <div className="mgdestn"> <a href="#"> 
                              <img src="assets/img/hotels/hotels-places/del-sm.webp" alt="Delhi"/> </a> </div>
                            <div className="_pckgdscrptn">
                                <h5 className="htlnking"><a href="#" className="cab-service-vendor">Flexible Hourly Car Rentals in India</a></h5>
                                <div className="htlnking vendors-cab-sub-text">Hourly car rentals for affordable, flexible travel in Indian cities.</div>
                            </div>
                        </div>
                    </div>


                    <div className="col-lg-4">
                        <div className="ecpl_rbx tour-packaging-box-width">
                            <div className="mgdestn"> <a href="#">
                               <img src="assets/img/hotels/hotels-places/del-sm.webp" alt="Delhi"/> </a> </div>
                            <div className="_pckgdscrptn">
                                <h5 className="htlnking"><a href="#" className="cab-service-vendor">Domestic Airport Transfer</a></h5>
                                <div className="htlnking vendors-cab-sub-text">Book guaranteed airport transfers now with peace of mind, double refund!</div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</div>

      <Sliders2_Vendor />
      <Sliders3_Vendor />

      <div className="about-company-main-sec mb-5">
        <div className="container">
          <div className="row">
            <div className="boxv1">
              <h5 className="tour-details-h5">Medical Tourism</h5>

              <p className="description-p">Experience World-Class Healthcare Combined with Unforgettable Travel through Medical Tourism</p>

              <p className="description-p">Discover the perfect blend of quality healthcare and travel through our specialized Medical Tourism Services. India has emerged as a global hub for affordable and world-class medical treatments, offering advanced medical facilities, skilled professionals, and personalized care.</p>

              <p className="description-p">Discover the perfect blend of healthcare and travel with our Medical Tourism services. We provide access to world-class medical treatments at affordable costs, partnering with top hospitals and skilled professionals. From treatment planning and travel arrangements to comfortable accommodations and post-treatment leisure tours, we ensure a seamless experience. Combine your healthcare journey with exploring India’s cultural heritage and wellness retreats for relaxation and recovery. Your health and comfort are our priorities.</p>

            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default VendorDetails
